import React from 'react';
import { connect } from 'react-redux';

import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useApp, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

const IncreaseUsaLimitModal = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const { notNowButton, increaseLimitButtonText, increaseLimitPurpleTitle, increaseLimitText } = usePageMessages();
    const { increaseLimitUrl, increaseLimitMaxAmount, increaseLimitCurrencyAmount } = useExtra();

    const text = (
        <>
            <span>{increaseLimitPurpleTitle}</span>
            <br />
            {resolveArguments(increaseLimitText, getLocalizedRawAmount(lang, country, increaseLimitMaxAmount, 0, '.', ','))} {increaseLimitCurrencyAmount}
        </>
    );

    return (
        <ModalComponent isVerticalCentered canCloseModal={false}>
            <InfoPage
                insideModalComponent
                iconName="zap-80"
                iconColor="primary"
                topButtonCaption={notNowButton}
                topButtonOnClick={() => {
                    props.toggleModal(false);
                }}
                primaryButtonCaption={increaseLimitButtonText}
                primaryButtonType={'link'}
                primaryButtonLink={increaseLimitUrl}
                headerText={text}
                primaryButtonOnClick={() => {
                    props.toggleSpinner(true);
                }}
            />
        </ModalComponent>
    );
};
export default connect(null, { toggleModal, toggleSpinner })(IncreaseUsaLimitModal);
